import { useTranslation } from "react-i18next";
import * as flags from "country-flag-icons/react/3x2";

import { getWorkplacesThunk } from "../../../redux/slices/authSlice/asyncthunk";
import { useAppDispatch } from "../../../hooks/redux/useRedux";

const LANGUAGES = [
  { code: "en", label: "english", countryCode: "US" },
  { code: "es", label: "spanish", countryCode: "ES" },
];

export const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();
  const dispatch = useAppDispatch();
  const onSelectLanguage = (code: string) => {
    i18n.changeLanguage(code);
    dispatch(getWorkplacesThunk());
  };

  return (
    <div className="flex gap-8 mt-2 self-center">
      {LANGUAGES.map((lang) => {
        const isActive = i18n.language === lang.code;
        const FlagIcon = flags[lang.countryCode as keyof typeof flags];

        return (
          <button
            key={lang.code}
            type="button"
            onClick={() => onSelectLanguage(lang.code)}
            className="flex flex-col items-center gap-2 bg-transparent border-none cursor-pointer p-0 "
          >
            <div
              className={`rounded-full transition-all duration-200 ${
                isActive
                  ? "ring-[3px] border-[#020637] ring-[#020637]"
                  : "ring-0"
              }`}
            >
              <div className="w-14 h-14 rounded-full overflow-hidden">
                {FlagIcon && (
                  <FlagIcon
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transform: "scale(1.4)",
                    }}
                  />
                )}
              </div>
            </div>
            <span className="text-[13px] text-neutral-500 font-normal">
              {t(`languages.${lang.label}`)}
            </span>
          </button>
        );
      })}
    </div>
  );
};
